import React from "react";

export default function H1(props) {
  return (
    <h1 className="font-medium  tracking-widest text-xl md:text-3xl lg:text-4xl text-white mb-4">
      {props.children}
    </h1>
  );
}
